import StyledDialog from "../../../../common/components/dialog/StyledDialog";
import { IRecentEventsTableRow } from "../models/common/events.models";
import FeedbackForm from "./FeedbackForm";

interface FeedbackDialogProps {
  open: boolean;
  submitLoading?: boolean;
  rowData?: IRecentEventsTableRow;
  onClose: () => void;
  onSubmitClick: (
    params: IRecentEventsTableRow,
    mitigatedRisk: string[]
  ) => void;
}

const FeedbackDialog = ({
  submitLoading,
  open,
  onClose,
  rowData,
  onSubmitClick,
}: FeedbackDialogProps) => {
  if (!rowData) {
    return null;
  }

  return (
    <StyledDialog
      open={open}
      onClose={onClose}
      showSubmitButton={false}
      title="Mitigated Risk, Avoided Liabilities"
      subTitle="Select all applicable risks mitigated or liabilities avoided"
    >
      <FeedbackForm
        submitLoading={submitLoading}
        rowData={rowData}
        onSubmitClick={onSubmitClick}
        onCancel={onClose}
      />
    </StyledDialog>
  );
};

export default FeedbackDialog;
